<template>
  <v-card elevation="0">
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <v-text-field
            v-model="form.reg_no"
            :label="$t('setting.label.reg_no') || 'Registration Number'"
            outlined
            dense
            hide-details="auto"
          />
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <v-row>
        <v-col cols="12" class="d-flex justify-end gap-2">
          <v-btn
            text
            @click="loadSettings"
            class="mr-2"
          >
            {{ $t('button.reset') || 'Reset' }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            @click="update"
          >
            {{ $t('button.save') || 'Save' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Registration',
  data () {
    return {
      form: {
        reg_no: ''
      },
      loading: false
    }
  },
  methods: {
    loadSettings () {
      this.$configService.getConfig()
        .then(data => {
          this.form.reg_no = data.company_reg_no
        })
    },
    update () {
      this.loading = true
      this.$configService.setConfig(this.form, 'reg')
        .then(data => {
          this.displayMessage(this.$t('status.success'))
        })
        .catch(this.globalErrHandle)
        .then(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('setting.tabs.registration') || 'Registration')
    this.$emit('parent-description', this.$t('setting.desc.registration') || '')
    this.loadSettings()
  }
}
</script>
